<template>
  <div :class="{ 'has-logo': showLogo }" :style="{ backgroundColor:'var(--base-menu-background)'}">
    <logo v-if="showLogo" :collapse="isCollapse"/>
    <el-scrollbar wrap-class="scrollbar-wrapper layout-sidebar">
      <el-menu
          :default-active="activeMenu"
          :collapse="isCollapse"
          background-color="var(--base-menu-background)"
          text-color="var(--base-menu-color)"
          :unique-opened="true"
          :active-text-color="theme"
          :collapse-transition="false"
          mode="vertical"
      >
        <sidebar-item
            v-for="(route, index) in sidebarRouters"
            :key="route.path + index"
            :item="route"
            :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script setup>
import Logo from './Logo'
import SidebarItem from './SidebarItem'
// import variables from '@/assets/styles/variables.module.scss'
import useAppStore from '@/store/modules/app'
import useSettingsStore from '@/store/modules/settings'
import usePermissionStore from '@/store/modules/permission'

const route = useRoute();
const appStore = useAppStore()
const settingsStore = useSettingsStore()
const permissionStore = usePermissionStore()

const sidebarRouters = computed(() => permissionStore.sidebarRouters);
const showLogo = computed(() => settingsStore.sidebarLogo);
const sideTheme = computed(() => settingsStore.sideTheme);
const theme = computed(() => settingsStore.theme);
const isCollapse = computed(() => !appStore.sidebar.opened);

const activeMenu = computed(() => {
  const {meta, path} = route;
  // if set path, the sidebar will highlight the path you set
  if (meta.activeMenu) {
    return meta.activeMenu;
  }
  return path;
})

</script>
<style lang="scss">
.layout-sidebar {
  .el-menu {
    .el-menu-item {
      --active-menu-bg:#fff;
      --el-menu-hover-bg-color: rgba(255, 255, 255, 0.7);
      position: relative;
      z-index: 0;

      &.is-active {
        --el-menu-active-color: var(--el-color-primary);
        background: transparent;
        &:before{
          position: absolute;
          z-index: -1;
          height: inherit;
          left: 10px;
          right: 0;
          top: 0;
          border-radius: 8px 0 0 8px;
          background: var(--active-menu-bg);
          content: '';
        }
      }
    }
  }
}
</style>
